module.exports = __webpack_public_path__ + "img/77.7.Chla.1ca1db9b.png";